import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ActivateProjectMutationVariables = Types.Exact<{
  input: Types.ActivateProjectInput;
}>;


export type ActivateProjectMutation = { __typename?: 'Mutation', activateProject?: { __typename?: 'ActivateProjectPayload', project?: { __typename?: 'Project', id: string, workspaceId: string, archivedAt?: string | null, updatedAt?: string | null } | null } | null };


export const ActivateProject = /*#__PURE__*/ gql`
    mutation ActivateProject($input: ActivateProjectInput!) {
  activateProject(input: $input) {
    project {
      id
      workspaceId
      archivedAt
      updatedAt
    }
  }
}
    ` as unknown as DocumentNode<ActivateProjectMutation, ActivateProjectMutationVariables>;

          

          export const useActivateProjectMutation = (options?:MutationHookOptions<ActivateProjectMutation, ActivateProjectMutationVariables>) => useMutation(ActivateProject, options);
          

          export type ActivateProjectMutationOptions = MutationHookOptions<ActivateProjectMutation, ActivateProjectMutationVariables>;

          

          export type ActivateProjectMutationResult = ReturnType<typeof useActivateProjectMutation>[1];

          
